module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-line-xl-496b8bba8fd7bdac9c5fe6497c4d621a.svg";